import * as React from 'react';
import { Button } from '@cian/ui-kit';
import * as styles from './PhoneButton.css';

export interface IPhoneButtonProps {
  phoneVisible: boolean;
  phone: string;
  placeholder: string;
  showPhone(): void;
}

export const PhoneButton: React.VFC<IPhoneButtonProps> = ({ phoneVisible, phone, placeholder, showPhone }) => {
  return phoneVisible ? (
    <div className={styles['phone']}>{phone}</div>
  ) : (
    <Button fullWidth size="XS" onClick={showPhone} data-name="CardPhoneButton">
      {placeholder}
    </Button>
  );
};
